import * as z from 'zod';

const TIME_PATTERN = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/;

export const correctionFormSchema = z
  .object({
    LeaveRequestType: z.enum(['fullday', 'halfday']).default('fullday'),
    ClockStartTime: z.string().regex(TIME_PATTERN, { message: 'INVALID_TIME_FORMAT' }),
    ClockEndTime: z.string().regex(TIME_PATTERN, { message: 'INVALID_TIME_FORMAT' }),
    Comment: z.string().optional(),
    // Breaks are optional: a row left blank is ignored, a half-filled one is an error.
    BreakTimes: z
      .array(
        z
          .object({
            Start: z.union([
              z.literal(''),
              z.string().regex(TIME_PATTERN, { message: 'INVALID_TIME_FORMAT' }),
            ]),
            End: z.union([
              z.literal(''),
              z.string().regex(TIME_PATTERN, { message: 'INVALID_TIME_FORMAT' }),
            ]),
            // A pre-filled lunch stays a lunch (its own rules apply); new rows are regular breaks.
            Type: z.enum(['Regular', 'Lunch']).default('Regular'),
          })
          .refine((entry) => !entry.Start === !entry.End, {
            message: 'BREAK_START_AND_END_REQUIRED',
            path: ['End'],
          })
      )
      .default([]),
  })
  // An end time before the start time is a shift that runs past midnight into the next day.
  .refine((data) => data.ClockStartTime !== data.ClockEndTime, {
    message: 'START_AND_END_TIME_MUST_DIFFER',
    path: ['ClockEndTime'],
  });

export type CorrectionFormValues = z.infer<typeof correctionFormSchema>;

/** The break rows the employee filled in; blank rows are dropped. */
export const filledBreakTimes = (values: CorrectionFormValues) =>
  values.BreakTimes.filter((entry) => entry.Start && entry.End);
